// tslint:disable
/**
 * Ux
 * insightux admin api
 *
 * The version of the OpenAPI document: 0.62
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import * as runtime from '../runtime';
import { objectToHash } from "common/object-helper";
import { PriceFromJSON, } from '../models';
/**
 * Get prices for a public market index
 * Get Public Market Indices Prices
 */
export function getPmiPricesByIdRaw(requestParameters, requestConfig = {}) {
    if (requestParameters.id === null || requestParameters.id === undefined) {
        throw new runtime.RequiredError('id', 'Required parameter requestParameters.id was null or undefined when calling getPmiPricesById.');
    }
    let queryParameters = null;
    let queryString = "";
    const headerParameters = {};
    const { meta = {} } = requestConfig;
    meta.authType = ['bearer'];
    const config = {
        url: runtime.BASE_PATH + `/pmis/{id}/prices`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))) + queryString,
        meta,
        update: requestConfig.update || {
            PmiPrices: (prevValue, transformedValue) => {
                return { ...prevValue, ...transformedValue };
            }
        },
        force: requestConfig.force,
        options: requestConfig.options || {
            method: 'GET',
            headers: headerParameters,
        },
        body: queryParameters,
        transform: requestConfig.transform ? requestConfig.transform : (body, text) => {
            const objResponse = body.map(PriceFromJSON);
            return {
                PmiPrices: objResponse.reduce((map, obj) => {
                    map[obj.id] = obj;
                    return map;
                }, {})
            };
        }
    };
    config.queryKey = requestConfig.queryKey || `GetPmiPricesById-${objectToHash(requestParameters)}`;
    return config;
}
/**
* Get prices for a public market index
* Get Public Market Indices Prices
*/
export function getPmiPricesById(requestParameters, requestConfig) {
    return getPmiPricesByIdRaw(requestParameters, requestConfig);
}
